import { SUPPLIER_COVER_FALLBACK } from './suppliers';

export const SUPPLIER_PREVIEW_ITEMS = [
  {
    supplier_id: 'preview-atelier-lumiere',
    slug: 'atelier-lumiere',
    public_name: 'Atelier Lumiere',
    company_name: 'Atelier Lumiere',
    category: 'Foto e video',
    city: 'Sao Paulo',
    state: 'SP',
    short_description: 'Cobertura autoral para casamentos elegantes, com direcao editorial e olhar cinematografico.',
    full_description: 'O Atelier Lumiere cria registros com atmosfera sofisticada, enquadramentos autorais e acabamento pensado para casais que valorizam imagem e memoria. A proposta combina documental com direcao leve para entregar fotos e filmes com percepcao premium.',
    cover_image: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=1400&q=80',
    whatsapp: '5511999991001',
    instagram: 'atelierlumiere.weddings',
    website_url: 'https://atelierlumiere.example.com',
    plan_type: 'premium_plus',
    is_homepage_featured: true,
    is_verified: true,
    rating: 5.0,
    review_count: 121,
    starting_price: 3800,
    promotion_count: 1,
    promotion_discount: 8,
  },
  {
    supplier_id: 'preview-casa-fiora',
    slug: 'casa-fiora',
    public_name: 'Casa Fiora',
    company_name: 'Casa Fiora',
    category: 'Decoracao',
    city: 'Campinas',
    state: 'SP',
    short_description: 'Florais esculturais e decoracao de atmosfera para casamentos contemporaneos.',
    full_description: 'A Casa Fiora trabalha com composicoes florais, cenografia e table styling para eventos com linguagem mais refinada. O foco esta em criar impacto visual e assinatura estetica para casais que buscam uma experiencia memoravel.',
    cover_image: 'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?auto=format&fit=crop&w=1400&q=80',
    whatsapp: '5511999992002',
    instagram: 'casafiora.studio',
    website_url: 'https://casafiora.example.com',
    plan_type: 'premium',
    is_homepage_featured: true,
    is_verified: false,
    rating: 5.0,
    review_count: 49,
    starting_price: 2600,
    promotion_count: 1,
    promotion_discount: 5,
  },
  {
    supplier_id: 'preview-villa-aurora',
    slug: 'villa-aurora',
    public_name: 'Villa Aurora',
    company_name: 'Villa Aurora',
    category: 'Espaco',
    city: 'Belo Horizonte',
    state: 'MG',
    short_description: 'Espaco para casamentos intimistas com arquitetura romantica e recepcao de alto padrao.',
    full_description: 'A Villa Aurora oferece saloes, jardim e operacao de evento para casais que querem um casamento elegante em ambiente exclusivo. A curadoria do espaco valoriza luz natural, atendimento proximo e experiencia acolhedora.',
    cover_image: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1400&q=80',
    whatsapp: '5531999993003',
    instagram: 'villaauroraeventos',
    website_url: 'https://villaaurora.example.com',
    plan_type: 'free',
    is_homepage_featured: false,
    is_verified: false,
    rating: 4.9,
    review_count: 34,
    starting_price: 5200,
    promotion_count: 0,
    promotion_discount: 0,
  },
  {
    supplier_id: 'preview-orquestra-vera',
    slug: 'orquestra-vera',
    public_name: 'Orquestra Vera',
    company_name: 'Orquestra Vera',
    category: 'Musica e DJ',
    city: 'Rio de Janeiro',
    state: 'RJ',
    short_description: 'Trilha musical ao vivo para cerimonias e festas com repertorio personalizado.',
    full_description: 'A Orquestra Vera desenha experiencias sonoras para casamento com repertorio personalizado, arranjos sob medida e operacao musical completa da cerimonia a festa.',
    cover_image: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?auto=format&fit=crop&w=1400&q=80',
    whatsapp: '5521999994004',
    instagram: 'orquestravera',
    website_url: 'https://orquestravera.example.com',
    plan_type: 'premium',
    is_homepage_featured: false,
    is_verified: true,
    rating: 5.0,
    review_count: 19,
    starting_price: 3200,
    promotion_count: 1,
    promotion_discount: 3,
  },
  {
    supplier_id: 'preview-amanda-assessoria',
    slug: 'amanda-lopes-assessoria',
    public_name: 'Amanda Lopes Assessoria e Cerimonial',
    company_name: 'Amanda Lopes Assessoria e Cerimonial',
    category: 'Assessoria e cerimonial',
    city: 'Rio de Janeiro',
    state: 'RJ',
    short_description: 'Cerimonial com acompanhamento proximo, operacao elegante e foco em tranquilidade no grande dia.',
    full_description: 'Amanda Lopes atua com assessoria e cerimonial para casais que querem um evento fluido, organizado e acolhedor. O trabalho combina planejamento, cronograma e coordenacao de fornecedores para reduzir estresse e elevar a experiencia.',
    cover_image: 'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1400&q=80',
    whatsapp: '5521999995005',
    instagram: 'amandalopes.cerimonial',
    website_url: 'https://amandalopes.example.com',
    plan_type: 'premium',
    is_homepage_featured: true,
    is_verified: true,
    rating: 5.0,
    review_count: 49,
    starting_price: 1600,
    promotion_count: 1,
    promotion_discount: 10,
  },
  {
    supplier_id: 'preview-flavio-cortat',
    slug: 'flavio-cortat-celebrante',
    public_name: 'Flavio Cortat Celebrante',
    company_name: 'Flavio Cortat Celebrante',
    category: 'Assessoria e cerimonial',
    city: 'Rio de Janeiro',
    state: 'RJ',
    short_description: 'Cerimonias personalizadas com narrativa leve, emocao e presenca de palco.',
    full_description: 'Flavio cria celebracoes com texto sob medida e conducao calorosa, equilibrando emocao, personalidade e leveza para casamentos em diversos formatos.',
    cover_image: 'https://images.unsplash.com/photo-1520854221256-17451cc331bf?auto=format&fit=crop&w=1400&q=80',
    whatsapp: '5521999996006',
    instagram: 'flaviocortat',
    website_url: 'https://flaviocortat.example.com',
    plan_type: 'premium_plus',
    is_homepage_featured: true,
    is_verified: true,
    rating: 5.0,
    review_count: 121,
    starting_price: 3000,
    promotion_count: 1,
    promotion_discount: 0,
  },
  {
    supplier_id: 'preview-casartelli',
    slug: 'casartelli-cerimonial',
    public_name: 'Casartelli Cerimonial',
    company_name: 'Casartelli Cerimonial',
    category: 'Assessoria e cerimonial',
    city: 'Rio de Janeiro',
    state: 'RJ',
    short_description: 'Cerimonial para casais que buscam producao organizada com linguagem classica e segura.',
    full_description: 'A Casartelli coordena cronograma, recepcao e operacao do evento com presenca discreta e atencao a detalhes para casamentos em diferentes escalas.',
    cover_image: 'https://images.unsplash.com/photo-1545239351-1141bd82e8a6?auto=format&fit=crop&w=1400&q=80',
    whatsapp: '5521999997007',
    instagram: 'casartellicerimonial',
    website_url: 'https://casartelli.example.com',
    plan_type: 'premium',
    is_homepage_featured: false,
    is_verified: false,
    rating: 5.0,
    review_count: 14,
    starting_price: 3400,
    promotion_count: 1,
    promotion_discount: 3,
  },
  {
    supplier_id: 'preview-o-altar-do-sim',
    slug: 'o-altar-do-sim',
    public_name: 'O Altar do Sim',
    company_name: 'O Altar do Sim',
    category: 'Assessoria e cerimonial',
    city: 'Rio de Janeiro',
    state: 'RJ',
    short_description: 'Cerimonias ao ar livre e projetos personalizados para casais que valorizam atmosfera.',
    full_description: 'O Altar do Sim desenvolve experiencias romanticas com foco em ambientacao, condução e acompanhamento do evento do inicio ao fim.',
    cover_image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=1400&q=80',
    whatsapp: '5521999998008',
    instagram: 'oaltardosim',
    website_url: 'https://oaltardosim.example.com',
    plan_type: 'premium',
    is_homepage_featured: false,
    is_verified: false,
    rating: 5.0,
    review_count: 19,
    starting_price: 2000,
    promotion_count: 1,
    promotion_discount: 5,
  },
];

export function getSupplierPreviewBySlug(slug) {
  return SUPPLIER_PREVIEW_ITEMS.find((item) => item.slug === slug) || null;
}

export function getFeaturedSupplierPreviews(limit = 3) {
  const featured = SUPPLIER_PREVIEW_ITEMS.filter((item) => item.is_homepage_featured);
  const fallback = featured.length > 0 ? featured : SUPPLIER_PREVIEW_ITEMS;
  return fallback.slice(0, limit);
}

export function getSupplierPreviewWithFallback(item) {
  return {
    cover_image: SUPPLIER_COVER_FALLBACK,
    ...item,
  };
}
